import { render, staticRenderFns } from "./OligoelementsSection.vue?vue&type=template&id=be949626&scoped=true&"
import script from "./OligoelementsSection.vue?vue&type=script&lang=js&"
export * from "./OligoelementsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be949626",
  null
  
)

export default component.exports